import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import Button from '../../shared/atoms/Button';
import BillingAddressModal from './BillingAddressModal';
// Icons
import Plus16 from '../../icons/Plus16';

const AddBillingAddress = ({ clientId, onAdded }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    onAdded();
  };

  return (
    <>
      <BillingAddressModal
        open={open}
        onRequestClose={() => setOpen(false)}
        clientId={clientId}
        mode="create"
        onSuccess={handleSuccess}
      />
      <Button before={<Plus16 />} mb={7} onClick={() => setOpen(true)}>
        {t('billingaddresses.add.cta')}
      </Button>
    </>
  );
};

export default AddBillingAddress;
